// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KtnQ","rootNoMargin":"styles_rootNoMargin__1bcAW"};